$(".header__icon--menu").click(function() {
   $(this).parents('sticky-header').toggleClass('drawer-open');
});




$(document).ready(function() {
  $(".tab-accordion-wrapper-q").click(function() {
    $(this).parents('.tab-accordion-wrapper').toggleClass('open');
    $(this).parents('.tab-accordion-wrapper').find('.tab-accordion-wrapper-a').slideToggle();
  });

  $(".tab-accordion-wrapper.open").each(function() {
    $(this).find('.tab-accordion-wrapper-a').show();
  });
});
